import moment, { Moment } from 'moment';
import { useEffect, useRef } from 'react';

import { analytics } from '@features/analytics';
import { DenialReason } from '@features/analytics/utilities/analytics.types';

type DenialAnalyticsParams = {
  isFetching: boolean;
  hasAvailability: boolean;
  itemCategory: string;
  itemId?: string;
  itemName: string;
  fromDate?: Moment | string;
  toDate?: Moment | string;
};

export function useDenialAnalytics({
  isFetching,
  hasAvailability,
  itemCategory,
  itemId,
  itemName,
  fromDate,
  toDate,
}: DenialAnalyticsParams) {
  const hasFired = useRef(false);
  const startDate = moment(fromDate).format('YYYY-MM-DD');
  const endDate = moment(toDate).format('YYYY-MM-DD');

  useEffect(() => {
    if (isFetching) {
      hasFired.current = false;
      return;
    }
    if (hasAvailability || hasFired.current) return;

    analytics.track({
      event: 'denial',
      params: {
        reason: DenialReason.NO_AVAILABILITY,
        start_date: startDate,
        end_date: endDate,
        items: [{ item_category: itemCategory, item_id: itemId, item_name: itemName }],
      },
    });
    hasFired.current = true;
  }, [isFetching, hasAvailability, itemCategory, itemId, itemName, startDate, endDate]);
}
